// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"dad884e9","455":"1f1e38e9","977":"2a5b92e5"}[chunkId] + ".chunk.js";
};